<template>
  <section v-if="result" class="insurance-result-card">
    <h4>推荐选购结果</h4>
    <!-- 各结果页共用此图，按原比例完整展示保险方提供的保障与保费说明。 -->
    <img
      class="banner"
      src="@/assets/images/insurance/result-banner.jpg"
      alt="个人意外险介绍"
      width="750"
      height="328"
    />
    <dl>
      <dt>保险产品</dt>
      <dd>{{ result.productName || '—' }}</dd>
      <dt>申请状态</dt>
      <dd>{{ statusText }}</dd>
      <template v-if="result.policyNo"
        ><dt>保单号</dt>
        <dd>{{ result.policyNo }}</dd></template
      >
    </dl>
    <p v-if="result.failMsg" class="failure">{{ result.failMsg }}</p>
    <!-- 各结果模板共用正式服务主体名称，避免继续展示公司占位文案。 -->
    <p class="tips">
      {{
        statusText
      }}。本服务由第三方机构【上海汇中保险经纪有限责任公司】提供，购买支付费用与本平台无任何关联。如产生争议，请与第三方机构联系。
    </p>
  </section>
</template>
<script>
import { stopResultRecording } from '@/utils/insuranceRecorder'
import { readInsuranceResult } from '@/utils/insuranceResult'
import { getInsuranceResult } from '@/api/insurance'
export default {
  name: 'InsuranceResult',
  data() {
    return { result: null }
  },
  watch: {
    // 仅携带保险流程标识时查询；兼容同一结果组件复用路由，普通进件不请求保险接口。
    '$route.query.insuranceResultKey': {
      immediate: true,
      handler: 'loadResult',
    },
  },
  methods: {
    async loadResult(key) {
      this.result = readInsuranceResult(key)
      if (!key) return
      try {
        const res = await getInsuranceResult()
        if (this.$route.query.insuranceResultKey !== key) return
        // 无记录时隐藏模块；查询失败保留本次提交结果，避免误报投保成功或失败。
        if (res && res.code === 200) this.result = res.data || null
      } catch (error) {
        // 网络异常沿用本次提交快照，不影响贷款结果区块展示。
      } finally {
        if (this.$route.query.insuranceResultKey === key)
          this.$nextTick(() =>
            requestAnimationFrame(() => requestAnimationFrame(stopResultRecording))
          )
      }
    },
  },
  computed: {
    statusText() {
      // 预投保与扣款中不能展示已支付；失败单独透出保险方原因。
      const labels = {
        0: '投保处理中',
        1: '绑卡中',
        2: '已绑卡',
        3: '订单已生成，待付费',
        4: '订单已生成，扣款中',
        5: '订单已生成，扣款成功',
        6: '退款成功',
        9: '预投保失败',
      }
      return this.result ? labels[this.result.status] || '处理中' : ''
    },
  },
}
</script>
<style scoped>
.insurance-result-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 15px;
  margin: 14px 0;
  color: #414751;
  font-size: 12px;
  line-height: 1.6;
}
h4 {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 12px;
}
.banner {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 8px;
}
dl {
  display: grid;
  grid-template-columns: 76px 1fr;
  gap: 8px;
  margin-top: 14px;
}
dt {
  color: #969aa2;
}
dd {
  text-align: right;
  margin: 0;
  overflow-wrap: anywhere;
}
.failure {
  color: #d95035;
  margin-top: 10px;
}
.tips {
  color: #999;
  font-size: 11px;
  margin-top: 12px;
}
</style>
